import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useAdminLeagues() {
  return useQuery({
    queryKey: ['admin-leagues'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('leagues')
        .select('id, name, season, created_at, settings')
        .order('created_at', { ascending: false });
      if (error) throw error;
      return data ?? [];
    },
  });
}

export function useAdminLeagueConfigs() {
  return useQuery({
    queryKey: ['admin-league-configs'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('league_configs')
        .select('league_id, competition_name');
      if (error) throw error;
      return data ?? [];
    },
  });
}

export function useAdminMemberCounts() {
  return useQuery({
    queryKey: ['admin-member-counts'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('league_memberships')
        .select('league_id')
        .eq('status', 'active');
      if (error) throw error;
      const counts = new Map<string, number>();
      for (const m of data ?? []) {
        counts.set(m.league_id, (counts.get(m.league_id) ?? 0) + 1);
      }
      return Array.from(counts.entries()).map(([league_id, count]) => ({ league_id, count }));
    },
  });
}

export function useAdminLeagueOwners() {
  return useQuery({
    queryKey: ['admin-league-owners'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('league_memberships')
        .select('league_id, display_name')
        .eq('role', 'owner');
      if (error) throw error;
      return data ?? [];
    },
  });
}
